
import { StrongFBJsonLayoutBuilderWidget } from "../StrongFB-interfaces";
import { StrongFBBaseWidgetHeader } from "../StrongFB-widget-header";

// card

import { StrongFBCardWidget } from "../../widgets/card/card.header";


// button

import { StrongFBButtonWidget } from "../../widgets/button/button.header";


// input

import { StrongFBInputWidget } from "../../widgets/input/input.header";


// form-field

import { StrongFBFormFieldWidget } from "../../widgets/form-field/form-field.header";


// textarea

import { StrongFBTextAreaWidget } from "../../widgets/textarea/textarea.header";


// editor

import { StrongFBEditorWidget } from "../../widgets/editor/editor.header";


// tags-list

import { StrongFBTagsListWidget } from "../../widgets/tags-list/tags-list.header";


export function json2WidgetClass(json: StrongFBJsonLayoutBuilderWidget) {
    let res: StrongFBBaseWidgetHeader;
    
    // =>check card widget
    if (json.type === 'card') {
        res = new StrongFBCardWidget();
    }
    
    
    // =>check button widget
    if (json.type === 'button') {
        res = new StrongFBButtonWidget();
    }
    

    
    // =>check input widget
    if (json.type === 'input') {
        res = new StrongFBInputWidget();
    }
    

    
    // =>check form field widget
    if (json.type === 'form-field') {
        res = new StrongFBFormFieldWidget();
    }
    

    
    // =>check textarea widget
    if (json.type === 'textarea') {
        res = new StrongFBTextAreaWidget();
    }
    

    
    // =>check editor widget
    if (json.type === 'editor') {
        res = new StrongFBEditorWidget();
    }
    

    
    // =>check tags-list widget
    if (json.type === 'tags-list') {
        res = new StrongFBTagsListWidget();
    }
    

    // =>parse json
    if (res) {
        res['_isJsonMode'] = true;
        if (res['_loadFromJson']) {
            res['_loadFromJson'](json.properties);
        } else {
            res['_schema'] = json.properties;
        }
        // =>load form field name
        if (json.formFieldName) {
            res['_formFieldName'] = json.formFieldName;
        }
        // =>load common styles
        if (json.commonStyles) {
            res['_commonStyles'] = json.commonStyles;
        }
    }

    return res;
}